import { SettingsRegular } from '@fluentui/react-icons';
export const settingsModule = {
    path: 'configuracoes',
    title: 'Configurações',
    icon: SettingsRegular,
    placement: 'footer',
    pages: [
        {
            path: 'preferencias',
            title: 'Preferências',
            description: 'Tema da aplicação neste navegador.',
            icon: SettingsRegular,
            // Sem permissão: preferências são de cada pessoa, não dependem de perfil.
            load: () => import('#src/modules/settings/SettingsPage.js').then((m) => m.SettingsPage),
        },
    ],
};
//# sourceMappingURL=settings.module.js.map